<div class="dashboard_background">
    <ng-container *ngIf="designGroups$ | async as designGroups">
      <div class="designGroupings">
        <ng-container *ngIf="designs$ | async as designs">
          <em-design-group (alteredDesign)="this.processDesignChange($event)" [designGroup]="this.getDefaultDesignGroup()" [designs]="this.getSortedDesign(designs, this.getDefaultDesignGroup().groupId)" [cardDeckId]="this.cardDeckId" [options]="this.options"></em-design-group>
          <ng-container *ngFor="let designGroup of this.getSortedDesignGroup(designGroups)">
              <em-design-group (alteredDesign)="this.processDesignChange($event)" [designGroup]="designGroup" [designs]="this.getSortedDesign(designs, designGroup.groupId)" [cardDeckId]="this.cardDeckId" [options]="this.options"></em-design-group>
          </ng-container>
        </ng-container>
      </div>
    </ng-container>
</div>
